<template><span>{{followersCount}}</span></template>
<script>
	export default {
	props: ['count'],
	data: function () {
		return {
			followersCount: 0
		};
	},
	methods: {
		setCount: function ({ count }) {
			this.followersCount = count;
		}
	},
	mounted: function () {
		this.followersCount = parseInt(this.count, 10);
		this.$eventHub.$on('followEvent', this.setCount);
	}
}
</script>